import React from "react";
import { useSelector } from "react-redux";
import PageHeader from "../common/PageHeader";
import withRedirect from "../../helpers/hoc/withRedirect";
import SupportLink from "../root/support/components/SupportLink";
import CondominiumList from "./CondominiumList2";
import OnboardingChecklist from "../onboarding/OnboardingChecklist";

const Condominium = ({ setRedirectUrl, setRedirect }) => {
  const { selectedCondominium } = useSelector((state) => state.condominium);

  return (
    <>
      <PageHeader
        title="Condominios"
        titleTag="h2"
        description="Gestiona cada uno de tus condominios."
        className="mb-3"
        col={{ lg: 9 }}
      >
        <SupportLink />
      </PageHeader>
      {/* Misma guia de primeros pasos que va en el Inicio: quien entra directo
          a Condominios no tiene que pasar por el Dashboard para verla. Solo se
          muestra con un condominio seleccionado (es su estado lo que guia). */}
      {selectedCondominium && <OnboardingChecklist />}
      <CondominiumList showPagination={true} />
    </>
  );
};

export default withRedirect(Condominium);
